import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Smartphone = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.0001 35.4167C23.8495 35.4167 22.9167 36.3494 22.9167 37.5C22.9167 38.6506 23.8495 39.5833 25.0001 39.5833H25.0197C26.1703 39.5833 27.103 38.6506 27.103 37.5C27.103 36.3494 26.1703 35.4167 25.0197 35.4167H25.0001Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5834 2.41669C11.3157 2.41669 8.66675 5.06567 8.66675 8.33335V41.6667C8.66675 44.9344 11.3157 47.5834 14.5834 47.5834H35.4167C38.6844 47.5834 41.3334 44.9344 41.3334 41.6667V8.33335C41.3334 5.06567 38.6844 2.41669 35.4167 2.41669H14.5834ZM12.1667 8.33335C12.1667 6.99867 13.2487 5.91669 14.5834 5.91669H35.4167C36.7514 5.91669 37.8334 6.99867 37.8334 8.33335V41.6667C37.8334 43.0014 36.7514 44.0834 35.4167 44.0834H14.5834C13.2487 44.0834 12.1667 43.0014 12.1667 41.6667V8.33335Z"
        fill={color}
      />
    </svg>
  )
}
